import { MenuHelper, IMenuDefinition, menuType } from "@/helpers/MenuHelper";
import vuestore from '@/store';
import { AreaSpecieProvenienzaStore } from './store/areaSpecieProvenienza.store';
import { dashboardHelper } from '@/helpers/DashboardHelper';
import Counter from "./components/dashboard/counter.vue";
import { securityService } from '@/services/securityService';
import { layoutHelper } from '@/helpers/LayoutHelper';

export function init() {
  const userRoles  = securityService.getInfo()?.roles;

  if (layoutHelper.isWeb && userRoles.includes("Amministratore")){
    MenuHelper.addMenuDefinition(
      { name: "areeSpecieProvenienza", description: "Aree per Specie/Provenienza", icon: "icon-uf_areespecie", routeName: "areeSpecieProvenienza", orderIndex: 1, group: "Censimento ex situ" } as IMenuDefinition,
      { section: menuType.drawer },
    );
    dashboardHelper.addComponent(Counter, "exsitu");
  }

  //REGISTRAZIONE DELLO STORE
  vuestore.registerModule(AreaSpecieProvenienzaStore.PREFIX, AreaSpecieProvenienzaStore);
}

export const parentSymbol = {
  type: "simple-fill",
  color: [60, 179, 113, 0.1],
  outline: {
    color: [255, 255, 255],
    width: 2
  }
};
export const symbol = {
  type: "simple-fill",
  color: [60, 179, 113, 0.8],
  outline: {
    color: [255, 255, 255],
    width: 2
  }
};


export const invalidSymbol = {
  type: "simple-fill",
  style: "diagonal-cross",
  color: [255, 0, 0],
  outline: {
    color: [255, 255, 255],
    width: 2
  }
}
